import Plotly from "react-plotly.js"

export const OrientationReadinessChart = ({orientee}) => {
    const weeks = []
    const orienteeScores = []
    const unitScores = []

    const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000
    // Timeframe is measured from the orientation start date; expected_end_date already
    // accounts for the standard length plus educator shifts and paused weeks.
    const start = orientee.start_date ? new Date(orientee.start_date) : null
    const expectedEnd = orientee.expected_end_date ? new Date(orientee.expected_end_date) : null
    const expectedWeeks = start && expectedEnd ? Math.round((expectedEnd - start) / MS_PER_WEEK) : 0

    // Cap the axis to the orientation's calculated length. Only extend past it when we
    // actually have score data there, so empty weeks aren't padded out to the hire-based
    // current week (which can sit far beyond the start-anchored orientation window).
    let weeksToShow = expectedWeeks
    const dataWeeks = [...Object.keys(orientee.unit_weekly_scores ?? {}), ...Object.keys(orientee.weeks ?? {})].map(
        Number
    )
    if (dataWeeks.length) {
        weeksToShow = Math.max(weeksToShow, ...dataWeeks)
    }

    for (let i = 1; i <= weeksToShow; i++) {
        weeks.push(`Wk ${i}`)
        orienteeScores.push(orientee.weeks?.[i]?.osr_avg?.percent_of_max_osr_score || 0)
        unitScores.push(orientee.unit_weekly_scores?.[i] || 0)
    }
    // Bars stay per-week; thin the tick labels to every other week once the chart exceeds 20 weeks.
    const tickVals = weeks.length > 20 ? weeks.filter((_, idx) => idx % 2 === 0) : weeks
    const bsPrimary = window.getComputedStyle(document.documentElement).getPropertyValue("--bs-primary").trim()
    const bsSecondary = window.getComputedStyle(document.documentElement).getPropertyValue("--bs-secondary").trim()
    const dataTraces = [
        {
            x: weeks,
            y: unitScores,
            legendgroup: "unitReadinessScore",
            showlegend: true,
            name: "Unit Average Readiness Scores",
            type: "bar",
            marker: {color: bsSecondary},
            textposition: "auto",
            offsetgroup: 1,
            alignmentgroup: 1,
        },
        {
            x: weeks,
            y: orienteeScores,
            legendgroup: "myReadinessScore",
            showlegend: true,
            name: "My Readiness Scores",
            type: "bar",
            width: 0.3,
            marker: {color: bsPrimary},
            textposition: "auto",
            offsetgroup: 1,
            alignmentgroup: 1,
        },
    ]
    if (weeks.length === 0) {
        return (
            <div className="card-body p-5 d-flex flex-column justify-content-center align-items-center">
                <p className="text-muted">No readiness scores available yet.</p>
            </div>
        )
    }

    return (
        <div className="card-body p-5 h-350px">
            <Plotly
                data={dataTraces}
                layout={{
                    autosize: true,
                    barmode: "group",
                    font: {
                        family: "Inter, sans-serif"
                    },
                    hovermode: "x unified",
                    legend: {
                        orientation: "h",
                        x: 0.5,
                        y: 1.15,
                        xanchor: "center",
                        yanchor: "bottom",
                    },
                    margin: {l: 50, r: 10, t: 10, b: 50, pad: 6},
                    xaxis: {tickmode: "array", tickvals: tickVals, ticktext: tickVals},
                    yaxis: {ticksuffix: "%", range: [0, 100]},
                }}
                config={{responsive: true}} // Makes the chart responsive
                style={{width: "100%", height: "100%"}}
            />
        </div>
    )
}
